var map = {
	"./flags/icon-flag--ca.svg": "./src/assets/icons/flags/icon-flag--ca.svg",
	"./flags/icon-flag--eu.svg": "./src/assets/icons/flags/icon-flag--eu.svg",
	"./flags/icon-flag--uk.svg": "./src/assets/icons/flags/icon-flag--uk.svg",
	"./flags/icon-flag--usa.svg": "./src/assets/icons/flags/icon-flag--usa.svg",
	"./icon-3d-model.svg": "./src/assets/icons/icon-3d-model.svg",
	"./icon-arrow--cta-long.svg": "./src/assets/icons/icon-arrow--cta-long.svg",
	"./icon-arrow--cta.svg": "./src/assets/icons/icon-arrow--cta.svg",
	"./icon-arrow--down.svg": "./src/assets/icons/icon-arrow--down.svg",
	"./icon-arrow--left-dis.svg": "./src/assets/icons/icon-arrow--left-dis.svg",
	"./icon-arrow--left.svg": "./src/assets/icons/icon-arrow--left.svg",
	"./icon-arrow--right-dis.svg": "./src/assets/icons/icon-arrow--right-dis.svg",
	"./icon-arrow--right.svg": "./src/assets/icons/icon-arrow--right.svg",
	"./icon-arrow--up.svg": "./src/assets/icons/icon-arrow--up.svg",
	"./icon-cart.svg": "./src/assets/icons/icon-cart.svg",
	"./icon-check--circle.svg": "./src/assets/icons/icon-check--circle.svg",
	"./icon-chevron--down.svg": "./src/assets/icons/icon-chevron--down.svg",
	"./icon-chevron--right.svg": "./src/assets/icons/icon-chevron--right.svg",
	"./icon-close.svg": "./src/assets/icons/icon-close.svg",
	"./icon-dispenser-product.svg": "./src/assets/icons/icon-dispenser-product.svg",
	"./icon-envelope.svg": "./src/assets/icons/icon-envelope.svg",
	"./icon-list.svg": "./src/assets/icons/icon-list.svg",
	"./icon-location.svg": "./src/assets/icons/icon-location.svg",
	"./icon-lock.svg": "./src/assets/icons/icon-lock.svg",
	"./icon-minus.svg": "./src/assets/icons/icon-minus.svg",
	"./icon-pause.svg": "./src/assets/icons/icon-pause.svg",
	"./icon-peercheck.svg": "./src/assets/icons/icon-peercheck.svg",
	"./icon-phone.svg": "./src/assets/icons/icon-phone.svg",
	"./icon-play.svg": "./src/assets/icons/icon-play.svg",
	"./icon-plus.svg": "./src/assets/icons/icon-plus.svg",
	"./icon-question-mark.svg": "./src/assets/icons/icon-question-mark.svg",
	"./icon-remove.svg": "./src/assets/icons/icon-remove.svg",
	"./icon-return.svg": "./src/assets/icons/icon-return.svg",
	"./icon-search.svg": "./src/assets/icons/icon-search.svg",
	"./icon-shipping.svg": "./src/assets/icons/icon-shipping.svg",
	"./icon-slide--left.svg": "./src/assets/icons/icon-slide--left.svg",
	"./icon-slide--right.svg": "./src/assets/icons/icon-slide--right.svg",
	"./icon-tooltip.svg": "./src/assets/icons/icon-tooltip.svg",
	"./icon-trail-marker.svg": "./src/assets/icons/icon-trail-marker.svg",
	"./icon-triangle--down.svg": "./src/assets/icons/icon-triangle--down.svg",
	"./icon-triangle--right.svg": "./src/assets/icons/icon-triangle--right.svg",
	"./icon-triangle--up.svg": "./src/assets/icons/icon-triangle--up.svg",
	"./social-icons/icon-facebook-blog.svg": "./src/assets/icons/social-icons/icon-facebook-blog.svg",
	"./social-icons/icon-facebook.svg": "./src/assets/icons/social-icons/icon-facebook.svg",
	"./social-icons/icon-instagram-blog.svg": "./src/assets/icons/social-icons/icon-instagram-blog.svg",
	"./social-icons/icon-instagram.svg": "./src/assets/icons/social-icons/icon-instagram.svg",
	"./social-icons/icon-linkedin-blog.svg": "./src/assets/icons/social-icons/icon-linkedin-blog.svg",
	"./social-icons/icon-linkedin.svg": "./src/assets/icons/social-icons/icon-linkedin.svg",
	"./social-icons/icon-pinterest-blog.svg": "./src/assets/icons/social-icons/icon-pinterest-blog.svg",
	"./social-icons/icon-pinterest.svg": "./src/assets/icons/social-icons/icon-pinterest.svg",
	"./social-icons/icon-rss.svg": "./src/assets/icons/social-icons/icon-rss.svg",
	"./social-icons/icon-shopify-logo.svg": "./src/assets/icons/social-icons/icon-shopify-logo.svg",
	"./social-icons/icon-snapchat.svg": "./src/assets/icons/social-icons/icon-snapchat.svg",
	"./social-icons/icon-tiktok-blog.svg": "./src/assets/icons/social-icons/icon-tiktok-blog.svg",
	"./social-icons/icon-tumblr.svg": "./src/assets/icons/social-icons/icon-tumblr.svg",
	"./social-icons/icon-twitter-blog.svg": "./src/assets/icons/social-icons/icon-twitter-blog.svg",
	"./social-icons/icon-twitter.svg": "./src/assets/icons/social-icons/icon-twitter.svg",
	"./social-icons/icon-vimeo.svg": "./src/assets/icons/social-icons/icon-vimeo.svg",
	"./social-icons/icon-youtube-blog.svg": "./src/assets/icons/social-icons/icon-youtube-blog.svg",
	"./social-icons/icon-youtube.svg": "./src/assets/icons/social-icons/icon-youtube.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/icons sync recursive \\.svg$";